import React from 'react';
import cx from 'classnames';
import { Tooltip } from 'react-scale/components/design-system';
import { capitalize } from 'lodash';

interface CourseTypePillProps {
  type: string;
  compact?: boolean;
}

const CourseTypePill: React.FC<CourseTypePillProps> = ({ type, compact }) => {
  const getLabel = (type: string) => {
    if (type === '') {
      return 'N/A';
    }
    return compact ? type.slice(0, 3) : type;
  };
  const getTooltip = (type: string) => {
    if (type === '') {
      return 'Course type not specified';
    } else if (!compact) {
      return '';
    }
    return capitalize(type) + ' course';
  };

  return (
    <>
      <Tooltip title={getTooltip(type)}>
        <div className={cx('pill', 'imageannotation', { fullsize: !compact, compact })}>
          <span className="label">{getLabel(type)}</span>
        </div>
      </Tooltip>

      <style jsx>{`
        .pill {
          margin-left: 2px;
          background: #616dcc;
          padding: 1ex;
          padding-inline: 11px;
          display: flex;
          border-radius: 50px;
        }
        .fullsize {
          min-width: 3em;
          font-size: 11px;
        }
        .compact {
          font-size: 12px;
        }
        .label {
          letter-spacing: 0.5px;
          font-weight: bold;
          text-transform: uppercase;
          color: #fff;
        }
      `}</style>
    </>
  );
};

export default CourseTypePill;
